import {
    SelectField,

} from "melco-shared-logic";

type DisplayBlankDropDownProps = {
    name?:string;
    label?:string;
};

export const DisplayBlankDropDown: React.FC<DisplayBlankDropDownProps> = ({name, label }) => {

    return (

        <SelectField
            name={name ?? ""}
            label={label ?? ""}
            options={([]).map((levelSub) => {
                return {
                    label: "",

                    value: "",
                };
            })}
            showSearch
            optionFilterProp="label"
        />

    );
};
